import { useNavigate } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { DEFAULT_ORGANIZATION_NAME, FOUNDER_FIRST_NAME } from "../config/vertical";

/**
 * Primer ingreso — lo único que ve un Socio Fundador nuevo justo después de
 * abrir su enlace de invitación (backend/app/main.py redirige aquí, no a
 * "/"). Full-bleed, sin Sidebar/TopBar: el primer momento no debe sentirse
 * como entrar a un software, sino como que alguien lo estaba esperando.
 */
export default function Welcome() {
  const navigate = useNavigate();
  const greetingName = FOUNDER_FIRST_NAME ? `, ${FOUNDER_FIRST_NAME}` : "";

  return (
    <div className="min-h-screen bg-[#0d1321] text-zinc-100 flex items-center justify-center px-5 sm:px-8">
      <div className="max-w-xl text-center">
        <div className="text-[11px] text-amber-500 font-mono uppercase tracking-[0.35em] mb-6">
          Commercial Operator
        </div>
        <h1 className="font-display font-black text-3xl sm:text-4xl md:text-5xl tracking-tight text-zinc-50 leading-tight">
          Bienvenido{greetingName}.
        </h1>
        <p className="text-lg text-zinc-400 mt-5 leading-relaxed">
          Tú dedícate a vender. Commercial Operator revisa tu cartera y cada día
          te dice con quién conviene hablar primero.
        </p>
        <p className="text-sm text-zinc-600 mt-3">
          {DEFAULT_ORGANIZATION_NAME}
        </p>
        <button
          onClick={() => navigate("/", { replace: true })}
          className="mt-10 w-full sm:w-auto inline-flex items-center justify-center gap-2 text-sm font-medium px-8 py-4 bg-amber-500 text-black hover:bg-amber-400 btn-glow-amber"
        >
          Comenzar mi día <ArrowUpRight size={16} />
        </button>
      </div>
    </div>
  );
}
